import React, { useEffect, useState } from "react";
import TextField from "../../Shared/TextField";
import DropDownField from "../../Shared/DropdownField";
import CheckBoxField from "../../Shared/CheckBoxField";
import { USER_FILTERS } from "../../constants/UserFilter";
import { DisplayMsg } from "../../services/toastService";
import { EMAIL_REGEX } from "../../constants/regex";
import { setUrl } from "../../handlers";

const AddUser = (props) => {
  const [Teams, setTeams] = useState([]);
  const [UserInfo, setUserInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    trainer: false,
  });
  const [Trigger, setTrigger] = useState({
    Qrcode: false,
    support: false,
    emailDisable: false,
  });

  const [ErrorInfo, setErrorInfo] = useState({
    firstName: false,
    email: false,
    lastName: false,
  });

  useEffect(() => {
    if (Teams.length < 1) {
      LoadTeams();
    }
    LoadUserData();
  }, []);

  const LoadUserData = () => {
    if (props.supportUser != null) {
      const user = props.supportUser;
      setTrigger((btnTrigger) => ({
        ...btnTrigger,
        emailDisable: true,
      }));

      if (
        user.ACTIVE === "Y" &&
        user.ACCOUNT_ACTIVATED !== "N" &&
        user.IS_2FAC === "Y"
      ) {
        setTrigger((btnTrigger) => ({
          ...btnTrigger,
          Qrcode: true,
        }));
      } else {
        setTrigger((btnTrigger) => ({
          ...btnTrigger,
          Qrcode: false,
        }));
      }

      setUserInfo((userInfo) => ({
        ...userInfo,
        firstName: user.FIRST_NAME,
        lastName: user.LAST_NAME,
        email: user.EMAIL,
        type: user.TYPE,
        team: user.TEAM,
        viewOnly:
          !(user.VIEW_ONLY === "N" || user.VIEW_ONLY == null),
        active: !(user.ACTIVE === "N" || user.ACTIVE == null),
        authentication:
          !(user.IS_2FAC === "N" || user.IS_2FAC == null),
        support:
          !(user.SHOW_SUPPORT === "N" || user.SHOW_SUPPORT == null),
        reseller: !(user.RESELLER === "N" || user.RESELLER == null),
        trainer: !!(user.TRAINER === "Y" || user.TRAINER == null),
      }));

      if (user.TYPE === "M") {
        setTrigger((btnTrigger) => ({
          ...btnTrigger,
          support: true,
        }));
      }
    } else {
      setTrigger((btnTrigger) => ({
        ...btnTrigger,
        Qrcode: false,
      }));

      setUserInfo((userInfo) => ({
        ...userInfo,
        active: true,
      }));
    }
  };

  const LoadTeams = async () => {
    try {
      const user = props.supportUser;
      document.getElementById("loader").style.display = "block";
      const response = await fetch(setUrl("USER", "LOADTEAMDROPDOWN"));
      const json = await response.json();
      if (json && json.status) {
        const teams = JSON.parse(json.dataTeam);
        if (user != null) {
          if (teams != null && teams.length > 0) {
            teams.forEach((team) => {
              if (team.SEQ_NUM === user.TEAM) {
                setUserInfo((userInfo) => ({
                  ...userInfo,
                  teamsLabel: team.Name,
                  teamsValue: team.SupportTeamId,
                  teamsEmail: team.Email,
                }));

              }
            });
          }
        }
        const teamData = {
          label: "- Select -",
          value: "",
        };

        setTeams((prevTeam) => [...prevTeam, teamData]);

        teams.forEach((team, key) => {
          const teamData = {
            label: team.Name,
            value: team.SupportTeamId,
          };
          setTeams((prevTeam) => [...prevTeam, teamData]);
        });
      }
      document.getElementById("loader").style.display = "none";
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const SendQrCode = async () => {
    try {
      document.getElementById("loader").style.display = "block";
      const formData = new FormData();
      formData.append(
        "SeqNum",
        props.supportUser != null ? props.supportUser.SEQ_NUM : ""
      );
      formData.append("Email", UserInfo.email);

      const result = await fetch(setUrl("USER", "SEND_QR_CODE"), {
        method: "POST",
        body: formData,
      });
      const response = await result.json();
      if (response.status === true) {
        DisplayMsg("1", response.Message);
      } else {
        DisplayMsg("2", response.Message);
      }
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const SaveUser = async () => {
    try {
      let check = true;

      for (const item in UserInfo) {
        if (item === "email" || item === "lastName" || item === "firstName") {
          if (UserInfo[item].length < 1) {
            setErrorInfo((errorInfo) => ({
              ...errorInfo,
              [item]: true,
            }));
            check = false;
          }
        }
      }

      if (check === true) {
        document.getElementById("loader").style.display = "block";
        const formData = new FormData();
        formData.append(
          "SeqNum",
          props.supportUser != null ? props.supportUser.SEQ_NUM : ""
        );
        formData.append("FName", UserInfo.firstName);
        formData.append("LName", UserInfo.lastName);
        formData.append("Email", UserInfo.email);
        formData.append("Type", UserInfo.type != null ? UserInfo.type : "");
        formData.append("ViewOnly", UserInfo.viewOnly == true ? "Y" : "N");
        formData.append("ShowSupport", UserInfo.support == true ? "Y" : "N");
        formData.append("Active", UserInfo.active == true ? "Y" : "N");
        formData.append("Trainer", UserInfo.trainer == true ? "Y" : "N");
        formData.append("CUCP", "");
        formData.append("CUReseller", UserInfo.reseller == true ? "Y" : "N");
        formData.append("TFA", UserInfo.authentication == true ? "Y" : "N");
        formData.append("team", UserInfo.team != null ? UserInfo.team : "");
        const result = await fetch(setUrl("USER", "SAVESUPPORTUSER", true), {
          method: "POST",
          body: formData,
        });
        const response = await result.json();
        if (
          response.status === true &&
          response.Message !== "User with this email already exist."
        ) {
          DisplayMsg("1", response.Message);
          UserPopup(false, true);
        } else {
          DisplayMsg("2", response.Message);
        }
      }
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const UserPopup = (type, reload) => {
    props.ParentCallBack({
      ...props.State,
      show: type,
      reloadGrid: reload,
    });
  };

  const FieldData = (textField) => {
    const curName = textField.fieldName;
    const curValue = textField.fieldValue;

    setUserInfo((prevData) => ({
      ...prevData,
      [curName]: curValue,
    }));

    for (const item in UserInfo) {
      if (curName === "email") {
        if (curValue.length < 1) {
          setErrorInfo((userInfo) => ({
            ...userInfo,
            email: true,
          }));
        } else if (EMAIL_REGEX.test(curValue)) {
          setErrorInfo((userInfo) => ({
            ...userInfo,
            email: false,
          }));
        } else {
          setErrorInfo((userInfo) => ({
            ...userInfo,
            email: "Email is Invalid",
          }));
        }
      } else {
        setErrorInfo((prevInfo) => ({
          ...prevInfo,
          [curName]: curValue.length < 1,
        }));
      }
    }
  };

  const FieldValue = (fieldName) => {
    let fieldValue;
    fieldValue = UserInfo[fieldName] != null ? UserInfo[fieldName] : "";
    return fieldValue;
  };

  return (
    <div id="popup4" className="overlay">
      <div className="popup">
        <div className="popup__header">
          <h3> {props?.supportUser != null ? 'Update User' : 'Add User'}  </h3>
          <span
            className="close"
            role="button"
            onClick={() => UserPopup(false, false)}
          >
            ×
          </span>
        </div>

        <div className="content">
          <div className="popup__body">
            <div className="row">
              <div className="col-md-6 col-sm-6">
                <TextField
                  id="firstName"
                  label="First Name:"
                  redMark
                  ReceivedTextData={FieldData}
                  value={FieldValue("firstName")}
                  requiredMsg={ErrorInfo.firstName}
                />
              </div>
              <div className="col-md-6 col-sm-6">
                <TextField
                  id="lastName"
                  label="Last Name:"
                  redMark
                  ReceivedTextData={FieldData}
                  value={FieldValue("lastName")}
                  requiredMsg={ErrorInfo.lastName}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-sm-6">
                <TextField
                  id="email"
                  label="Email:"
                  redMark
                  disabled={Trigger.emailDisable}
                  ReceivedTextData={FieldData}
                  value={FieldValue("email")}
                  requiredMsg={ErrorInfo.email}
                />
              </div>
              <div className="col-md-6 col-sm-6">
                <DropDownField
                  type="user"
                  id="type"
                  label="Type"
                  classDiv
                  required={false}
                  options={USER_FILTERS.TYPE_OPTIONS}
                  value={FieldValue("type")}
                  ReceivedTextData={FieldData}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-sm-6">
                <DropDownField
                  type="user"
                  id="team"
                  label="Team"
                  classDiv
                  required={false}
                  options={Teams}
                  value={FieldValue("team")}
                  ReceivedTextData={FieldData}
                />
              </div>
              <div className="col-md-6 col-sm-6" style={{ display: "none" }}>
                <TextField
                  type="user"
                  id="cp"
                  label="CP:"
                  redMark
                  ReceivedTextData={FieldData}
                  value={FieldValue("cp")}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-sm-12">
                <CheckBoxField
                  type="user"
                  id="viewOnly"
                  classClient
                  label="View Only"
                  value={FieldValue("viewOnly")}
                  ReceivedTextData={FieldData}
                />

                <CheckBoxField
                  type="user"
                  id="active"
                  classClient
                  label="Active"
                  value={FieldValue("active")}
                  ReceivedTextData={FieldData}
                />
                {Trigger.support && (
                  <CheckBoxField
                    type="user"
                    id="support"
                    classClient
                    label="Show Support"
                    value={FieldValue("support")}
                    ReceivedTextData={FieldData}
                  />
                )}

                <CheckBoxField
                  type="user"
                  id="authentication"
                  classClient
                  label="Two Factor Authenticator"
                  value={FieldValue("authentication")}
                  ReceivedTextData={FieldData}
                />

                <CheckBoxField
                  type="user"
                  id="trainer"
                  classClient
                  label="Trainer"
                  value={FieldValue("trainer")}
                  ReceivedTextData={FieldData}
                />

                <div className="input-checkbox d-none">
                  <CheckBoxField
                    type="user"
                    id="reseller"
                    classClient
                    label="Reseller"
                    value={FieldValue("reseller")}
                    ReceivedTextData={FieldData}
                  />
                </div>
              </div>
            </div>

            <div className="row text-center">
              <div className="col-md-12 col-sm-12">
                <input
                  type="button"
                  className="btnLinkGreen ClosePopup"
                  value={props.supportUser != null ? "Update" : "Save"}
                  onClick={() => SaveUser()}
                />

                <input
                  type="button"
                  className="btnCancel ClosePopup"
                  value="Cancel"
                  onClick={() => UserPopup(false, false)}
                />
                {Trigger.Qrcode && (
                  <input
                    type="button"
                    className="btnLinkGreen ClosePopup"
                    value="Send QR Code"
                    onClick={() => SendQrCode()}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
